import { EnergyLabelStoreService } from '@hb/modules/property/energy-label/energy-label-store.service';
import { EnergyLabelQuestion } from '@hb/domain';
import { EnergyLabelRadioComponent } from '@hb/modules/property/energy-label/energy-label-radio/energy-label-radio.component';
import { PreviousButtonComponent } from '@hb/modules/global/button';

import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';

@Component({
    selector: 'energy-label',
    templateUrl: './energy-label.component.html',
    standalone: true,
    imports: [ApContentModule, FormsModule, ReactiveFormsModule, ApRadioModule, PreviousButtonComponent, EnergyLabelRadioComponent]
})
export class EnergyLabelComponent implements OnInit, OnDestroy {
    protected readonly store = inject(EnergyLabelStoreService);

    private activeQuestion: EnergyLabelQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy(): void {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showEnergyLabel(): boolean {
        return (
            this.activeQuestion === EnergyLabelQuestion.ENERGY_LABEL_RADIO ||
            (this.store.isActiveQuestion(EnergyLabelQuestion.ENERGY_LABEL_RADIO) && this.store.isSummary)
        );
    }
}
